import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
} from '@/components/ui/card';
import React from 'react';
import { useAuthState, useAuthActions, constants } from '@/utils/auth';
import { cn } from '@/utils/utils';

const AuthConfirmEmailForm: React.FC = () => {
  const { error, emailConfirmationDestination, matches } = useAuthState();
  const { resendConfirmation } = useAuthActions();
  return (
    <div className={cn('flex flex-col gap-6')}>
      <Card>
        <CardHeader className="text-center">
          <CardDescription>
            {`Se envio un correo de confirmación a ${
              emailConfirmationDestination || 'tu dirección de email'
            }, chequea tu bandeja de entrada y usá el link que te enviamos para poder acceder a Bilderit.`}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col gap-6">
            <div className="text-center pt-1">
              {matches({ [constants.STATE_CONFIRM_EMAIL]: 'idle' }) && (
                <div className="text-center text-sm">
                  Si no recibiste el email, chequea tu carpeta de spam o{' '}
                  <Button
                    variant="link"
                    onClick={resendConfirmation}
                    className="underline underline-offset-4 p-0"
                  >
                    Reenviar
                  </Button>
                </div>
              )}
              {matches({ [constants.STATE_CONFIRM_EMAIL]: 'resend' }) && (
                <>
                  <LoadingSpinner className="mr-2" />
                  <span>Reenviando...</span>
                </>
              )}
            </div>
          </div>
          {error && (
            <span role="alert" className="mt-2 text-sm text-destructive">
              {error.message}
            </span>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default AuthConfirmEmailForm;
